/* eslint-disable */
require('./ads')
require('./calendar-user')
require('./customer')
require('./dashboard')
require('./email')
require('./example')
require('./eye')
require('./form')
require('./hospital')
require('./information')
require('./job')
require('./link')
require('./multiple-users-silhouette')
require('./nested')
require('./password')
require('./quality')
require('./roster')
require('./schedule')
require('./security-badge')
require('./settings-gears')
require('./table')
require('./tree')
require('./user')
require('./users')
